"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var d3_1 = require("d3");
var svg_helper_1 = require("../lib/svg-helper");
var Legend = /** @class */ (function () {
    function Legend(ctx) {
        /**
         * 过滤的数据系列名
         * @since 2.0
         */
        this.disabledKeys = [];
        /**
         * 整个图例的高度
         * @since 2.0
         */
        this.height = 0;
        /**
         * 整个图例区的宽度
         * @since 2.0
         */
        this.width = 0;
        /**
         * 图例svg对象的高度
         * @since 2.5
         */
        this.groupHeight = 0;
        /**
         * 图例svg对象的宽度
         * @since 2.5
         */
        this.groupWidth = 0;
        this.ctx = ctx;
        var _a = this.ctx, classPrefix = _a.classPrefix, root = _a.root, container = _a.container;
        this.container = d3_1.select(container)
            .append("div")
            .style("overflow", "hidden auto")
            .style("position", "relative");
        this.group = this.container
            .append("svg")
            .attr("data-z-index", "7")
            .attr("version", "1.1")
            .attr("xmlns", "http://www.w3.org/2000/svg")
            .style("-webkit-user-select", "none")
            .style("-moz-user-select", "none")
            .style("-ms-user-select", "none")
            .style("user-select", "none")
            .style("display", "block")
            .style("margin", "0 auto");
        this.box = this.group
            .append("rect")
            .attr("class", classPrefix + "-chart-legend-box")
            .attr("rx", "0")
            .attr("ry", "0")
            .attr("x", "0")
            .attr("y", "0")
            .attr("visibility", "visible")
            .attr("fill", "none");
        this.itemGroup = this.group.append("g").attr("data-z-index", "1");
    }
    /**
     *
     * @param serieScale 数据系列比例尺
     * @param valueKey
     */
    Legend.prototype.update = function (serieScale, valueKey, type, model) {
        var enable = this.ctx.getOption("legend.enable", true);
        var customLegend = this.ctx.getOption("legend.custom");
        var isCustom = typeof customLegend === "function";
        if (enable || isCustom) {
            var alias = this.ctx.getOption("scale." + valueKey + ".alias");
            var legendData = [];
            var domain = serieScale.domain();
            var total_1 = 0;
            for (var i = 0; i < domain.length; i++) {
                var col = domain[i];
                var values = model.getDataFromSerieName(col);
                var valueSum = d3_1.sum(values.map(function (i) { return i.value; }));
                total_1 += valueSum;
                legendData.push({
                    label: alias || (valueKey === "default" ? valueKey : col),
                    color: serieScale(col),
                    key: col,
                    type: type,
                    index: i,
                    values: values,
                    stat: {
                        sum: valueSum,
                        percent: 0,
                    },
                });
            }
            legendData = legendData.map(function (i) {
                i.stat.percent = i.stat.sum / total_1;
                return i;
            });
            if (isCustom) {
                customLegend(legendData);
            }
            if (enable) {
                this.draw(legendData);
            }
            else {
                this.clear();
            }
        }
        else {
            this.clear();
        }
    };
    /**
     * 清空图例
     * @private
     */
    Legend.prototype.clear = function () {
        var classPrefix = this.ctx.classPrefix;
        this.groupHeight = 0;
        this.height = 0;
        this.box.attr("height", this.groupHeight);
        this.group.attr("height", this.groupHeight);
        this.group.attr("viewBox", "0 0 " + this.groupWidth + " " + this.groupHeight);
        this.itemGroup.selectAll("." + classPrefix + "-chart-legend-item").remove();
    };
    Legend.prototype.draw = function (legendData) {
        var _this = this;
        var _a = this.ctx, classPrefix = _a.classPrefix, theme = _a.theme;
        var text = theme.legend.text;
        var chartWidth = parseInt(this.ctx.background.attr("width"), 10);
        var formatter = this.ctx.getOption("legend", {}).formatter;
        var cls = classPrefix + "-chart-legend-item";
        // 清除所有的图例项
        this.itemGroup.selectAll("." + cls).remove();
        var items = this.itemGroup.selectAll("." + cls).data(legendData);
        var maxTextWidth = 0;
        var enter = items
            .enter()
            .append("g")
            .attr("class", function (d) {
            return cls + " " + classPrefix + "-chart-" + d.type + "-series";
        })
            .call(function (g) {
            // 图例的色块
            g.each(function node(d, i) {
                var legendItemGroup = d3_1.select(this).style("cursor", "pointer");
                var generateText = function () {
                    var text = d.label;
                    if (formatter) {
                        text = formatter(d.label, i, legendData.length - 1 === i, legendData);
                    }
                    return text;
                };
                // title气泡
                legendItemGroup.append("title").text(generateText);
                if (d.type === "line") {
                    legendItemGroup
                        .append("path")
                        .attr("d", "M 0 11 L 16 11")
                        .attr("fill", "none")
                        .attr("stroke", d.color)
                        .attr("stroke-width", "2");
                }
                if (d.type === "pie") {
                    legendItemGroup
                        .append("rect")
                        .attr("width", 12)
                        .attr("height", 12)
                        .attr("rx", 6)
                        .attr("ry", 6)
                        .attr("fill", d.color)
                        .attr("y", 5);
                }
                legendItemGroup
                    .append("text")
                    .attr("x", 21)
                    .attr("y", 15)
                    .attr("text-anchor", "start")
                    .attr("data-z-index", "2")
                    .style("font-size", text.fontSize + "px")
                    .style("color", text.color)
                    .style("fill", text.color)
                    .append("tspan")
                    .text(generateText);
                var textWidth = svg_helper_1.nodeWidth(legendItemGroup.node());
                maxTextWidth = textWidth > maxTextWidth ? textWidth : maxTextWidth;
            });
        });
        var firstXOffset = 8;
        var xOffset = firstXOffset; // 每个图例项的 X 偏移量
        var yOffset = 3; // 每个图例项的 Y 偏移量
        var align = this.ctx.getOption("legend.align");
        items
            .merge(enter)
            .attr("transform", function setItemOffset() {
            if (align === "bottom") {
                var x_1 = xOffset;
                xOffset += maxTextWidth + 20;
                if (xOffset > chartWidth) {
                    xOffset = firstXOffset + maxTextWidth + 20;
                    yOffset += text.fontSize * 2;
                    return "translate(" + firstXOffset + ", " + yOffset + ")";
                }
                return "translate(" + x_1 + ", " + yOffset + ")";
            }
            var x = xOffset;
            var y = yOffset;
            yOffset += text.fontSize * 2;
            return "translate(" + x + ", " + y + ")";
        })
            .on("mouseenter", this.onLegendItemHover.bind(this))
            .on("mouseleave", this.onLegendItemLeft.bind(this))
            .on("click", this.onLegendItemClick.bind(this))
            .call(function (g) {
            g.selectAll("path").attr("fill", function (d) {
                return _this.disabledKeys.find(function (k) { return k === d.key; })
                    ? text.disabledColor
                    : d.color;
            });
            g.selectAll("text").style("fill", function (d) {
                return _this.disabledKeys.find(function (k) { return k === d.key; })
                    ? text.disabledColor
                    : text.color;
            });
        });
        this.groupWidth = Math.round(svg_helper_1.nodeWidth(this.itemGroup.node()) + 28);
        this.groupHeight = Math.round(svg_helper_1.nodeHeight(this.itemGroup.node()) + 6);
        this.box.attr("width", this.groupWidth);
        this.box.attr("height", this.groupHeight);
        this.group.attr("width", this.groupWidth);
        this.group.attr("height", this.groupHeight);
        this.group.attr("viewBox", "0 0 " + this.groupWidth + " " + this.groupHeight);
        this.setPosition();
    };
    /**
     * 更新图例区的位置
     * @since 2.0
     */
    Legend.prototype.setPosition = function () {
        var _a = this.ctx.getOption("legend"), align = _a.align, width = _a.width, height = _a.height, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, shiftUp = _a.shiftUp;
        var _b = this.ctx.theme.padding, bottom = _b.bottom, right = _b.right, top = _b.top;
        var chartWidth = parseInt(this.ctx.background.attr("width"), 10);
        var chartHeight = parseInt(this.ctx.background.attr("height"), 10);
        var x;
        var y;
        // 设置 container 的 width, height, maxWidth, maxHeight
        this.container.style("max-width", typeof maxWidth === "number"
            ? maxWidth + "px"
            : (maxWidth !== null && maxWidth !== void 0 ? maxWidth : (align === "bottom"
                ? chartWidth // 图例在下方，最大宽度需要默认撑开到最大，避免滚动条也居中了。
                : Math.min(this.groupWidth, chartWidth) // 图例在右方，最大宽度默认是图表实际宽度即可。
            ) + "px"));
        this.container.style("max-height", typeof maxHeight === "number"
            ? maxHeight + "px"
            : (maxHeight !== null && maxHeight !== void 0 ? maxHeight : Math.min(this.groupHeight, chartHeight) + "px"));
        this.container.style("width", typeof width === "number" ? width + "px" : (width !== null && width !== void 0 ? width : null));
        this.container.style("height", typeof height === "number" ? height + "px" : (height !== null && height !== void 0 ? height : null));
        // 获取 container 实际高度，更新到 width, height
        var _c = this.container.node().getBoundingClientRect(), containerWidth = _c.width, containerHeight = _c.height;
        this.width = containerWidth;
        this.height = containerHeight;
        if (align === "bottom") {
            x = Math.floor(chartWidth / 2) - Math.floor(this.width / 2);
            y = -bottom - this.height;
        }
        else if (align === "right") {
            x = chartWidth - right - this.width;
            // 图例高度小于图表高度，竖直居中
            if (this.height < chartHeight) {
                y =
                    -chartHeight +
                        Math.floor((chartHeight - top - bottom) / 2) -
                        Math.floor(this.height / 2);
            }
            else {
                // 图例高度大于图表高度，顶到最高即可，展示滚动条
                y = -chartHeight;
            }
        }
        if (shiftUp) {
            y -= shiftUp;
        }
        this.container.style("left", x + "px");
        this.container.style("top", y + "px");
    };
    Legend.prototype.onLegendItemHover = function (legendData) {
        // 被禁用的元素不需要触发 Hover 事件
        if (this.disabledKeys.includes(legendData.key))
            return;
        this.ctx.emit("legend.hover", legendData);
    };
    Legend.prototype.onLegendItemLeft = function (legendData) {
        this.ctx.emit("legend.left", legendData);
    };
    Legend.prototype.onLegendItemClick = function (legendData) {
        // eslint-disable-next-line no-unused-expressions
        d3_1.event && d3_1.event.stopPropagation();
        var key = legendData.key;
        var disabled = this.disabledKeys.findIndex(function (k) { return k === key; }) !== -1;
        var data = this.itemGroup
            .selectAll("." + this.ctx.classPrefix + "-chart-legend-item")
            .data();
        var index = data.findIndex(function (d) { return d.key === key; });
        if (disabled) {
            this.disabledKeys = this.disabledKeys.filter(function (k) { return k !== key; });
        }
        else {
            this.disabledKeys.push(key);
        }
        this.draw(data);
        this.ctx.emit("legend.clicked", data[index], !disabled);
        this.onLegendItemLeft(legendData);
    };
    return Legend;
}());
exports.Legend = Legend;
//# sourceMappingURL=legend.js.map